import { Network } from '@yme/services/network';
import { addToCache, getCachedResult } from './cache';
export const getMegamenuNavItems = async (megamenuURL) => {
    const cachedValue = getCachedResult(megamenuURL);
    if (cachedValue) {
        return Promise.resolve(cachedValue);
    }
    const response = await Network.get(megamenuURL);
    return addToCache(megamenuURL, response.data, 30);
};
